import Heading2 from "componentsTemplate/Heading/Heading2";
import { Route } from "routers/types";
import Link from "componentsTemplate/Link";
import React, { ReactNode } from "react";
import usePathname from "hooks/usePathname";
import { useParams } from "react-router-dom";

const Layout = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname();
  const { id }: any = useParams();

  const subPages: { href: Route; pageName: string; emoij: string }[] = [
    {
      href: `/${id}/perfil`,
      emoij: "",
      pageName: "Contato",
    },
    {
      href: `/${id}/dados-basicos`,
      emoij: "",
      pageName: "Perfil",
    },
    {
      href: `/${id}/contato-dicas`,
      emoij: "",
      pageName: "Dicas",
    },
    {
      href: `/${id}/contato-parcerias`,
      emoij: "",
      pageName: "Parcerias",
    },
    {
      href: `/${id}/contato-classificados`,
      emoij: "",
      pageName: "Classificados",
    },
    {
      href: `/${id}/contato-eventos`,
      emoij: "",
      pageName: "Eventos",
    }
  ];

  return (
    <div className={`nc-PageDashboard`}>
      {/* <span className="w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] m-5">
        <Link to={"/"}>Home</Link> &gt; <Link to={pathname}>{pathname.replace('/', '').replace('-', ' ')}</Link>
      </span><br /><br /> */}
      <div className="flex flex-col space-y-8 xl:space-y-0 xl:flex-row">
        {/* SIDEBAR */}

        <div className="flex-shrink-0 max-w-xl xl:w-80 xl:pr-8">
          <ul className="text-base space-y-1 text-neutral-700 dark:text-neutral-400">
            {subPages.map(({ href, pageName, emoij }, index) => {
              return (
                <li key={index}>
                  <Link
                    className={`px-6 py-3 font-medium rounded-full flex items-center ${
                      pathname === href
                        ? "bg-neutral-100 dark:bg-neutral-800 text-neutral-900 dark:text-neutral-100"
                        : "hover:text-neutral-800 hover:bg-neutral-100 dark:hover:bg-neutral-800 dark:hover:text-neutral-100"
                    }`}
                    href={href}
                  >
                    <span className="w-8 mr-2 text-lg">{emoij}</span>
                    <span> {pageName}</span>
                  </Link>
                </li>
              );
            })}

            <li className=" border-t border-neutral-200 dark:border-neutral-700" />
            {/* <li>
              <Link
                className={`flex items-center px-6 py-3 font-medium text-red-500`}
                href={"/"}
              >
                <span className="w-8 mr-2 text-lg"></span>
                Sair
              </Link>
            </li> */}
          </ul>
        </div>

        <div className="border-t border-neutral-500 dark:border-neutral-300 md:hidden"></div>

        <div className="flex-1">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
